import React from "react";
import { Navigate, useLocation } from "react-router-dom";

/**
 * Canonicalize legacy /b2b/* URLs to /gcb/* while preserving query/hash.
 * Keeps /b2b as a backwards-compatible alias but ensures the visible URL is /gcb.
 */
const B2BToGcbRedirect = () => {
  const location = useLocation();

  const nextPathname = location.pathname.replace(/^\/b2b(\/|$)/, "/gcb$1");
  const to = `${nextPathname}${location.search || ""}${location.hash || ""}`;

  return (
    <Navigate
      to={to}
      replace
    />
  );
};

export default B2BToGcbRedirect;

